/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A self-rollback: the updated build failed to start, so the agent restored the previous one.
 */
export type ManagedDeviceRollback = {
  /**
   * When the rollback happened.
   */
  at: Date;
  /**
   * Version the agent rolled back from.
   */
  from?: string | undefined;
  /**
   * Version the agent rolled back to.
   */
  to?: string | undefined;
};

/** @internal */
export const ManagedDeviceRollback$inboundSchema: z.ZodMiniType<
  ManagedDeviceRollback,
  unknown
> = z.object({
  at: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
  from: z.optional(z.string()),
  to: z.optional(z.string()),
});

export function managedDeviceRollbackFromJSON(
  jsonString: string,
): SafeParseResult<ManagedDeviceRollback, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ManagedDeviceRollback$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ManagedDeviceRollback' from JSON`,
  );
}
